import * as myxhr from "./myxhr.js";
import ReactGA from "react-ga";

export function drillCompleted(drillName, transcript) {
    ReactGA.pageview(`/z/training/${drillName}`);
    return myxhr.post(`/drill/${drillName}`, transcript);
}
